<template>
  <div>
    <a-button class="editable-add-btn" style="margin-bottom: 8px" @click="openAddPosition">添加广告位置</a-button>
    <a-table :columns="columns" :data-source="data" class="components-table-demo-nested" :rowKey="record => record.id"
      @expand="expand" :expandedRowKeys="expandedRowKeys">
      <template slot="operation" slot-scope="text,record">
        <div class="editable-row-operations">
          <a @click="openImage(record)">添加广告</a>
          <a-divider type="vertical" />
          <a @click="positionEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <a-popconfirm v-if="data.length" title="确定要删除吗?" @confirm="positionDelete(record.id)">
            <a>删除</a>
          </a-popconfirm>
        </div>
      </template>
      <template slot="status" slot-scope="text,record">
        <div>
          <a-tag :color="record.status == '1' ? 'green' : 'red'">{{ text == '1' ? '正常' : '异常' }}</a-tag>
        </div>
      </template>
      <a-table slot="expandedRowRender" :columns="innerColumns" :data-source="innerData" :rowKey="record => record.id"
        :pagination="false">
        <template slot="image" slot-scope="text">
          <img v-if="text" :src="text" width="100px" />
        </template>
        <span slot="status">
          <a-badge status="success" />Finished
        </span>
        <template slot="operation" slot-scope="text,record">
          <div class="editable-row-operations">
            <a @click="openEditImage(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm v-if="innerData.length" title="确定要删除吗?" @confirm="ImageDelete(record)">
              <a>删除</a>
            </a-popconfirm>
            <!-- <a-divider type="vertical" />
            <a @click="detail(record.id)">详情</a> -->
          </div>
        </template>
        <template slot="status" slot-scope="text,record">
          <div>
            <a-tag :color="record.status == '1' ? 'green' : 'red'">{{ text == '1' ? '正常' : '异常' }}</a-tag>
          </div>
        </template>
      </a-table>
    </a-table>
    <a-modal v-model="addPositionShow" :title="positionModalType == 'add' ? '添加广告位置' : '编辑广告位置'" @ok="addPosition"
      @cancel="addPositionShow = false">
      <a-form>
        <a-form-item label="名字" name="name">
          <a-input v-model="addPositionForm.name" />
        </a-form-item>
        <a-form-item label="图片位置" name="mark">
          <a-input v-model="addPositionForm.mark" />
        </a-form-item>
        <a-form-item label="状态" name="status">
          <a-select ref="select" v-model="addPositionForm.status" style="width: 120px" @change="positionStatus">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="0">异常</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-modal v-model="addImageShow" :title="imageModalType == 'add' ? '添加广告' : '编辑广告'" @ok="addImage"
      @cancel="addImageShow = false">
      <a-form>
        <a-form-item label="名字" name="name">
          <a-input v-model="addImageForm.name" />
        </a-form-item>
        <a-form-item label="链接" name="link_address">
          <a-input v-model="addImageForm.link_address" :disabled="imageModalType == 'edit'" />
        </a-form-item>
        <a-form-item label="图片" name="image">
          <img v-if="addImageForm.image" width="100px" :src="addImageForm.image" />
          <div>
            <or-upload v-model="addImageForm.image" :show="false" mode="image" @input="uploadfile" button-text="上传图片" />
          </div>
        </a-form-item>
        <a-form-item label="状态" name="status">
          <a-select ref="select" v-model="addImageForm.status" style="width: 120px" @change="imageStatus">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="0">异常</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- <a-modal v-model="editImageShow" title="编辑广告" @ok="ImageEdit" @cancel="editImageShow = false">
      <a-form>
        <a-form-item label="名字" name="name">
          <a-input v-model="editImageForm.name" />
        </a-form-item>
        <a-form-item label="图片" name="image">
          <img v-if="editImageForm.image" width="100px" :src="editImageForm.image" />
          <div>
            <or-upload v-model="editImageForm.image" :show="false" mode="image" @input="uploadfile"
              button-text="上传图片" />
          </div>
        </a-form-item>
        <a-form-item label="状态" name="status">
          <a-select ref="select" v-model="editImageForm.status" style="width: 120px" @change="editImageStatus">
            <a-select-option :value="1">正常</a-select-option>
            <a-select-option :value="0">异常</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal> -->
  </div>
</template>

<script>
import { cloneDeep } from 'lodash-es';
import { message, ATypographyLink, ATag } from 'ant-design-vue';
import * as moment from 'moment';
import OrUpload from "@/components/upload";

const innerColumns = [{
  title: 'ID',
  dataIndex: 'id',
  scopedSlots: { customRender: 'id' }
}, {
  title: '名字',
  dataIndex: 'name',
  width: '150px',
  scopedSlots: { customRender: 'name' }
}, {
  title: '图片',
  dataIndex: 'image',
  width: '300px',
  scopedSlots: { customRender: 'image' }
}, {
  title: '创建时间',
  dataIndex: 'create_time',
  scopedSlots: { customRender: 'create_time' }
}, {
  title: '状态',
  dataIndex: 'status',
  scopedSlots: { customRender: 'status' }
}, {
  title: '操作',
  dataIndex: 'operation',
  scopedSlots: { customRender: 'operation' }
}]
const innerRules = {
  name: [
    {
      required: true,
      message: '请输入图片名称',
      trigger: 'blur'
    },
  ],
  image: [
    {
      required: true,
      message: '请出入图片地址',
      trigger: 'blur',
    },
  ],
  status: [
    {
      required: true,
      message: '请选择图片状态',
      trigger: 'blur',
    },
  ],
};
const columns = [{
  title: 'ID',
  dataIndex: 'id',
  scopedSlots: { customRender: 'id' }
}, {
  title: '名字',
  dataIndex: 'name',
  width: '150px',
  scopedSlots: { customRender: 'name' }
}, {
  title: '图片位置',
  dataIndex: 'mark',
  width: '300px',
  scopedSlots: { customRender: 'mark' }
}, {
  title: '创建时间',
  dataIndex: 'create_time',
  scopedSlots: { customRender: 'create_time' }
}, {
  title: '状态',
  dataIndex: 'status',
  scopedSlots: { customRender: 'status' }
}, {
  title: '操作',
  dataIndex: 'operation',
  scopedSlots: { customRender: 'operation' }
}]
const rules = {
  name: [
    {
      required: true,
      message: '请输入图片名称',
      trigger: 'blur'
    },
  ],
  image: [
    {
      required: true,
      message: '请出入图片地址',
      trigger: 'blur',
    },
  ],
  status: [
    {
      required: true,
      message: '请选择图片状态',
      trigger: 'blur',
    },
  ],
};
export default {
  computed: {
    count: function () {
      if (this.innerData.length > 0) {
        return parseInt(this.innerData.at(-1).id) + 1
      } else {
        return 1
      }
    }
  },
  components: { OrUpload },
  data() {
    return {
      data: [],
      innerData: [],
      positionModalType: 'add',
      imageModalType: 'add',
      addPositionForm: {
        id: '',
        name: '',
        mark: '',
        status: 1
      },
      addPositionShow: false,
      addImageForm: {
        id: '',
        name: '',
        pid: '',
        image: '',
        link_address: '',
        status: 1
      },
      addImageShow: false,
      editImageForm: {
        id: '',
        name: '',
        pid: '',
        image: '',
        status: 1
      },
      editImageShow: false,
      columns,
      rules,
      innerColumns,
      innerRules,
      expandedRowKeys: []
    }
  },
  created() {
    this.getAdverPositionList()
  },
  methods: {
    uploadfile() {

    },
    expand(expanded, record) {
      if (this.expandedRowKeys.length > 0) { //进这个判断说明当前已经有展开的了
        //返回某个指定的字符串值在字符串中首次出现的位置，下标为0
        let index = this.expandedRowKeys.indexOf(record.id);
        if (index > -1) { //如果出现则截取这个id,1d到1相当于0，针对重复点击一个
          this.expandedRowKeys.splice(index, 1);
        } else {
          //如果没出现则截取所有id,添加点击id，0到1，针对已经有一个展开，点另一个会进入判断
          this.expandedRowKeys.splice(0, this.expandedRowKeys.length);
          this.expandedRowKeys.push(record.id);
        }
      } else {
        //数组长度小于0，说明都没展开，第一次点击，id添加到数组，数组有谁的id谁就展开
        this.expandedRowKeys.push(record.id);
      }
      if(expanded) this.getAdverList(record.id)
    },
    openAddPosition() {
      this.addPositionShow = true;
      this.positionModalType = 'add';
      this.addPositionForm = {
        id: '',
        name: '',
        mark: '',
        status: 1
      }
    },
    async addPosition() {
      try {
        let { id, name, mark, status } = this.addPositionForm;
        let res;
        console.log(this.positionModalType);
        if (this.positionModalType == 'add') {
          res = await this.$axios.post('/api/AdPosition/add', { data: { name, mark, status } });
        } else {
          res = await this.$axios.post('/api/AdPosition/edit', { data: { id, name, status } });
        }
        if (res.code === 200) {
          message.success(res.msg)
          this.addPositionShow = false;
          this.getAdverPositionList();
        } else {
          message.error(res.msg)
        }
      } catch (error) {
        console.log(error);
      }
    },
    positionEdit(record) {
      this.addPositionShow = true;
      this.positionModalType = 'edit';
      this.addPositionForm = {
        id: record.id,
        name: record.name,
        mark: record.mark,
        status: 1
      }
    },
    async positionDelete(id) {
      try {
        let { code, msg } = await this.$axios.post('/api/AdPosition/dell', { data: { id } })
        if (code === 200) {
          message.success(msg)
          this.data = this.data.filter(item => item.id !== id)
        } else {
          message.error(msg)
        }
      } catch (error) {
        console.log(error);
      }
    },
    openImage(record) {
      this.addImageShow = true;
      this.imageModalType = 'add';
      this.addImageForm = {
        name: '',
        pid: record.id,
        image: '',
        link_address: '',
        status: 1
      }
    },
    openEditImage(record) {
      this.addImageShow = true;
      this.imageModalType = 'edit';
      this.addImageForm = {
        id: record.id,
        name: record.name,
        pid: record.pid,
        image: record.image,
        status: record.status,
        link_address: record.link_address
      }
    },
    async ImageEdit() {
      try {
        let { id, name, pid, image } = this.editImageForm;
        let { code } = await this.$axios.post('/api/ad/edit', { data: { id, name, pid, image } })
        if (code === 200) {
          message.success('编辑成功')
        } else {
          message.error('编辑失败')
        }
      } catch (error) {
        console.log(error);
      }
    },
    async ImageDelete(record) {
      try {
        console.log(record);
        let { id, name, pid, image } = record;
        let { code, msg } = await this.$axios.post('/api/ad/dell', { data: { id, name, pid, image } })
        if (code === 200) {
          message.success('删除成功')
          this.innerData = this.innerData.filter(item => item.id !== id);
        } else {
          message.error('删除失败')
        }
      } catch (error) {
        console.log(error);
      }
    },
    async addImage() {
      try {
        let { id, name, pid, image, link_address } = this.addImageForm;
        let res;
        if (this.imageModalType == 'add') {
          res = await this.$axios.post('/api/ad/add', { data: { name, pid, image, link_address } })
        } else {
          res = await this.$axios.post('/api/ad/edit', { data: { id, name, pid, image } })
        }
        if (res.code === 200) {
          message.success(res.msg)
          this.addImageShow = false;
          this.getAdverList(pid)
        } else {
          message.error(res.msg)
        }
      } catch (error) {
        console.log(error);
      }
    },
    async handleChange() {
      try {
        let { id, status } = this.formState;
        let { code } = await this.$axios.post('/api/ad/ChangeStatus', { data: { id, status } });
        Object.assign(this.innerData.filter(item => id === item.id)[0], this.formState);
        if (code === 200) {
          message.success('状态修改成功')
        } else {
          message.error('状态修改失败')
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAdverList(pid) {
      try {
        let { code, data, msg } = await this.$axios.post('/api/ad/list', { data: { pid } });
        if (code === 200) {
          this.innerData = data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAdverPositionList() {
      try {
        let { code, data, msg } = await this.$axios.post('/api/AdPosition/list', { data: { mark: 'kaiping' } });
        if (code === 200) {
          this.data = data.map(item => {
            return {
              ...item,
              children: []
            }
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    async positionStatus() {
      /* try {
        if(this.positionModalType == 'edit'){
          
        }
      } catch (error) {
        console.log(error);
      } */
    },
    async imageStatus(status) {
      try {
        if (this.imageModalType == 'edit') {
          let id = this.addImageForm.id;
          let { code } = await this.$axios.post('/api/ad/ChangeStatus', { data: { id, status } });
          if (code === 200) {
            message.success('状态修改成功')
          } else {
            message.error('状态修改失败')
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>